import React from 'react';
import ContentLayout from '../../../components/ContentLayout';
import props from '../../../lib/contentLayoutProps/the-kingston-difference/layoutProps';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="en" pageKey="mission-purpose-and-the-kingston-difference">
    <h1>Mission, Purpose, and the Kingston Difference</h1>

    <h3>Mission Statement</h3>
    <p>
      To provide a challenging and stimulating bilingual (English and Putonghua) environment that nurtures the balanced
      development of students who, in their own unique way, grow into active and responsible world citizens.
    </p>

    <h3>Vision: Together We Are Committed To:</h3>
    <ul className="list">
      <li>Living peacefully together</li>
      <li>Prioritising people and relationships based on the principles of international-mindedness</li>
      <li>Assuming shared responsibility for learning, health and well-being</li>
      <li>
        Considering individual and collective perspectives while recognising the interdependence of everyone and
        everything
      </li>
      <li>Challenging fixed perspectives</li>
      <li>Building understandings of others’ identities, cultures, societies and histories</li>
      <li>Supporting opportunities to engage with different ways of knowing, being and taking action</li>
      <li>Establishing partnerships among all stakeholders, forming mutually rewarding and productive relationships</li>
      <li>Building and maintaining friendships, learning proactively and taking collective action</li>
      <li>Promoting student agency, encouraging voice, choice and ownership of our own learning</li>
      <li>
        Extending learning for all students by creating an affirmative and responsive environment that embraces learner
        diversity from a strength-based perspective
      </li>
      <li>Building and supporting a community that values inclusion</li>
    </ul>
  </ContentLayout>
);
